import React, { useEffect } from 'react';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import ReelMarquee from '../ReelMarquee/ReelMarquee';
import { pageTitle } from '../../helper';

export default function ReelsPage() {
  useEffect(() => {
    pageTitle('Reels Showcase');
  }, []);

  return (
    <>
      {/* Page Title Section */}
      <PageHeading
        title="Reels Showcase"
        bgSrc="/images/page-heading-bg.jpeg"
      />

      <Spacing lg="60" md="40" />

      <div className="container">
        <h2 className="cs-section_title">Our Reel Gallery</h2>
        <Spacing lg="30" md="20" />

        {/* Marquee Reel Component */}
        <ReelMarquee />
      </div>

      <Spacing lg="100" md="80" />
    </>
  );
}
